// extracted by mini-css-extract-plugin
export default {"Advisor":"z0msMHoW","Details":"WYxQVdN2","Name":"SNTTo5B7","Header":"Vv4z4vUV","SubHeader":"Buq7QBWp","isSelected":"QqtFKrvk"};